<template>
  <div v-if="isLoggedIn" class="appStatus">
    <!-- Checks validation only on Convert to Order -->
    <requirement-validation ref="requirement"></requirement-validation>
    <v-layout row wrap class="py-0">
      <v-flex v-if="rows[0].isQuote" xs3 lg2 class="py-1 px-2">
        <v-btn size="sm" color="secondary" @click="checkValidations(true)">
          Convert to Order
        </v-btn>
      </v-flex>
      <v-flex xs7 lg8 class="py-0 mx-3">
        <v-card width="100%" color="primary" dark>
          <v-card-text class="py-2 px-0">
            <v-layout v-if="customer.customer" row wrap>
              <v-flex v-if="rows[0]" sm2 md2 lg2 class="custom-field">
                <v-text-field
                  v-if="rows[0]"
                  title="'Status: '+ rows[0].orderStatus"
                  :label="rows[0].isQuote ? 'Quote:' : 'Order:'"
                  :value="`${rows[0].orderID}(${rows[0].orderStatus})`"
                  disabled
                  hide-details
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex
                v-if="customer.customer.ubAccountNo"
                sm3
                md3
                lg3
                class="custom-field"
              >
                <v-text-field
                  v-if="customer.customer.ubAccountNo"
                  v-model="customer.customer.ubAccountNo"
                  label="Vonex account number:"
                  disabled
                  hide-details
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex v-if="customerName" sm4 md4 lg3 class="custom-field">
                <v-text-field
                  v-if="customerName"
                  v-model="customerName"
                  label="Customer name:"
                  disabled
                  hide-details
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex
                v-if="customer.customer.companyDetails"
                sm4
                md4
                lg4
                class="custom-field"
              >
                <v-text-field
                  v-if="customer.customer.companyDetails"
                  v-model="customer.customer.companyDetails.companyName"
                  label="Company:"
                  disabled
                  hide-details
                  dense
                ></v-text-field>
              </v-flex>
              <!-- <v-flex sm12 md12 lg12 v-show="$route.name === 'appStatus'">
                  <blockquote>
                    To add products to this order, please select the appropriate links
                    from the left menu
                  </blockquote>
              </v-flex>-->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- </v-container> -->
    <v-dialog v-model="isDataLoading" modal persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Utils from '@/mixins/utils.mixin';
import { mapState, createNamespacedHelpers } from 'vuex';
import requirementValidation from '@/components/qantas/requirement-validation.vue';

const {
  mapState: mapOrderState,
  mapGetters: mapOrderGetters,
  mapMutations: mapOrderMutations,
  mapActions: mapOrderActions,
} = createNamespacedHelpers(`orders`);
const { mapActions: mapSummaryActions } =
  createNamespacedHelpers(`orders/summary`);
export default {
  name: 'AppStatus',
  computed: {
    ...mapOrderState([
      'auth',
      'customer',
      'dealer',
      'rows',
      'summary',
      'required_fields',
    ]),
    ...mapState('orders', ['summary', 'company']),
    ...mapOrderGetters([
      'isLoggedIn',
      'hasDealer',
      'hasOrder',
      'isAdmin',
      'isQantas',
      'isResidential',
      'isQuote',
    ]),
    customerName() {
      if (this.customer.customer.firstName && this.customer.customer.surname)
        return (
          this.customer.customer.firstName +
          ' ' +
          this.customer.customer.surname
        );

      if (this.customer.customer.firstName && !this.customer.customer.surname)
        return this.customer.customer.firstName;

      if (!this.customer.customer.firstName && this.customer.customer.surname)
        return this.customer.customer.surname;

      return '';
    },
  },
  components: {
    requirementValidation,
  },
  mounted() {
    let vm = this;
    vm.$eventBus.$on('showValidation', (val) => {
      if (vm.rows[0] && vm.rows[0].orderID > 0) {
        vm.onValidate(val);
      }
    });
  },
  mixins: [Utils],
  data() {
    return {
      isDataLoading: false,
      onConvert: false,
    };
  },
  methods: {
    ...mapOrderMutations(['setIsQuote', 'setRequiredFields']),
    ...mapSummaryActions(['populateSummary', 'resetSummary']),
    ...mapOrderActions(['duplicateOrder', 'getOrder']),
    onValidate(val) {
      let vm = this;
      vm.$nextTick(() => {
        if (this.$route.name.toLowerCase() != 'summary') {
          vm.populateSummary(vm.rows[0].orderID).then((res) => {
            if (vm.$refs.requirement) {
              vm.$refs.requirement.validateOrder(val);
            }
          });
        }
      });
    },
    checkValidations(convertOrder = false) {
      let vm = this;
      vm.isDataLoading = true;
      vm.onConvert = true;
      vm.resetSummary();
      vm.populateSummary(vm.rows[0].orderID).then((res) => {
        vm.isDataLoading = true;
        if (this.rows[0].isQuote) {
          vm.isDataLoading = false;
          vm.duplicateOrder(vm.rows[0].orderID).then((order) => {
            vm.getOrder(order.orderID);
            vm.setIsQuote(order.isQuote);
            vm.setRequiredFields([]);
            this.$emit('existingOrder', order.orderID);
            vm.$nextTick(() => {
              // vm.onValidate(convertOrder);
            });
          });
          // vm.setRequiredFields([]);
          // this.$router.push("/");
        } else {
          vm.$refs.requirement
            .validateOrder()
            .then((res) => {
              vm.isDataLoading = false;
              vm.duplicateOrder(vm.rows[0].orderID).then((order) => {
                vm.setRequiredFields([]);
                vm.$emit('existingOrder', order.orderID);
                vm.$nextTick(() => {
                  // vm.onValidate(convertOrder);
                });
              });
            })
            .catch((err) => {
              vm.isDataLoading = false;
            });
        }
      });
    },
    onClose(data) {
      this.onConvert = data;
    },
  },
};
</script>
<style scoped lang="scss">
.appStatus {
  min-width: 60% !important;
}
.custom-field {
  ::v-deep .theme--dark.v-input--is-disabled .v-label,
  .theme--dark.v-input--is-disabled input,
  .theme--dark.v-input--is-disabled textarea {
    color: #fff !important;
  }

  ::v-deep input {
    color: #fff !important;
  }

  ::v-deep .v-input__slot::before {
    border-style: none !important;
  }
}
</style>
